import React, { useCallback, useState } from 'react';
import { Form, Modal, Select, message } from 'antd';
import { useParams } from 'react-router-dom';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { SelectValue } from 'antd/lib/select';

import { useBaskets } from '../hooks/use-baskets';
import { BasketService } from '../services';
import { useBackgroundNavigate } from '@shared/hooks';

export const TransferBasketDeclarations = () => {
    const { t } = useTranslation();
    const navigate = useBackgroundNavigate();
    const { id } = useParams<{ id: string }>();

    const baskets = useBaskets();

    const [basket, setBasket] = useState('');

    const onTargetChange = useCallback((value: SelectValue) => {
        setBasket(value as string);
    }, [])

    const handleSubmit = useMutation({
        mutationFn: async () => {
            const response = await BasketService.transferDeclarations(id ?? '', basket);
            if (response.status === 200) {
                message.success(t('baskets.transferSuccess'))
                navigate('/baskets')
            } else {
                message.error(response.data)
            }
        }
    })

    return (
        <Modal
            open
            width={576}
            onCancel={() => navigate('/baskets')}
            title="Transfer"
            onOk={() => handleSubmit.mutate()}
            confirmLoading={handleSubmit.isLoading}
        >
            <Form size='large' layout='vertical'>
                <label>{t('baskets.targetBasket')}</label>
                <Select
                    style={{ width: '100%' }}
                    value={basket}
                    placeholder={t('baskets.targetBasket')}
                    onChange={onTargetChange}>
                    {baskets.data?.map(elem =>
                        <Select.Option
                            key={elem.id}
                            value={elem.id.toString()}>{elem.name}</Select.Option>)}
                </Select>
            </Form>
        </Modal >
    );
};
